import useT from '../../components/utils/Translations/useT';
export default function useIconsList() {
    const t = useT();
    return iconsList.map(item => ({ name: t(item), value: item }));
}
export const iconsList = [
    'home',
    'home2',
    'home3',
    'home4',
    'home5',
    'home6',
    'home7',
    'home8',
    'home9',
    'office',
    'city',
    'newspaper',
    'magazine',
    'design',
    'pencil',
    'pencil2',
    'pencil3',
    'pencil4',
    'pencil5',
    'pencil6',
    'pencil7',
    'eraser',
    'eraser2',
    'eraser3',
    'quill',
    'quill2',
    'quill3',
    'quill4',
    'pen',
    'pen-plus',
    'pen-minus',
    'pen2',
    'pen3',
    'pen4',
    'pen5',
    'marker',
    'marker2',
    'blog',
    'blog2',
    'pen6',
    'brush',
    'spray',
    'palette',
    'palette2',
    'color-sampler',
    'toggle',
    'bucket',
    'bucket2',
    'gradient',
    'eyedropper',
    'eyedropper2',
    'eyedropper3',
    'droplet',
    'droplet2',
    'droplet-contrast',
    'color-clear',
    'paint-format',
    'stamp',
    'images',
    'image',
    'image2',
    'image-compare',
    'images2',
    'image3',
    'images3',
    'image4',
    'image5',
    'image6',
    'camera',
    'camera2',
    'camera3',
    'shutter',
    'headphones',
    'headset',
    'music',
    'music2',
    'music3',
    'music4',
    'music5',
    'music6',
    'album',
    'cassette',
    'tape',
    'piano',
    'guitar',
    'trumpet',
    'speakers',
    'play',
    'play2',
    'clapboard-play',
    'administration',
    'clapboard',
    'media',
    'presentation',
    'movie',
    'film',
    'film2',
    'film3',
    'film4',
    'video-camera',
    'video-camera2',
    'video-camera-slash',
    'video-camera3',
    'video-camera4',
    'video-camera-slash2',
    'video-camera5',
    'recording',
    'dice',
    'gamepad',
    'gamepad2',
    'gamepad3',
    'pacman',
    'spades',
    'clubs',
    'diamonds',
    'chess-king',
    'chess-queen',
    'chess-rook',
    'chess-bishop',
    'chess-knight',
    'chess-pawn',
    'chess',
    'bullhorn',
    'megaphone',
    'new',
    'connection',
    'connection2',
    'connection3',
    'connection4',
    'podcast',
    'station',
    'station2',
    'antenna',
    'satellite-dish',
    'satellite-dish2',
    'feed',
    'podcast2',
    'antenna2',
    'mic',
    'mic-off',
    'mic2',
    'mic-off2',
    'mic3',
    'mic4',
    'mic5',
    'book',
    'book2',
    'book-play',
    'book3',
    'bookmark',
    'books',
    'archive',
    'reading',
    'library',
    'library2',
    'graduation',
    'file-text',
    'profile',
    'file-empty',
    'file-empty2',
    'files-empty',
    'files-empty2',
    'file-plus',
    'file-plus2',
    'file-minus',
    'file-minus2',
    'file-download',
    'file-download2',
    'file-upload',
    'file-upload2',
    'file-check',
    'file-check2',
    'file-eye',
    'file-eye2',
    'file-text2',
    'file-text3',
    'file-picture',
    'file-picture2',
    'file-music',
    'file-music2',
    'file-play',
    'file-play2',
    'file-video',
    'file-video2',
    'copy',
    'copy2',
    'file-zip',
    'file-zip2',
    'file-xml',
    'file-xml2',
    'file-css',
    'file-css2',
    'file-presentation',
    'file-presentation2',
    'file-stats',
    'file-stats2',
    'file-locked',
    'file-locked2',
    'file-spreadsheet',
    'file-spreadsheet2',
    'copy3',
    'copy4',
    'paste',
    'paste2',
    'paste3',
    'paste4',
    'stack',
    'stack2',
    'stack3',
    'folder',
    'folder-search',
    'folder-download',
    'folder-upload',
    'folder-plus',
    'folder-plus2',
    'folder-minus',
    'folder-minus2',
    'folder-check',
    'folder-heart',
    'folder-remove',
    'folder2',
    'folder-open',
    'folder3',
    'folder4',
    'folder-plus3',
    'folder-minus3',
    'folder-plus4',
    'folder-minus4',
    'folder-download2',
    'folder-upload2',
    'folder-download3',
    'folder-upload3',
    'folder5',
    'folder-open2',
    'folder6',
    'folder-open3',
    'certificate',
    'cc',
    'price-tag',
    'price-tag2',
    'price-tags',
    'price-tag3',
    'price-tags2',
    'price-tag4',
    'price-tags3',
    'price-tag5',
    'price-tags4',
    'primitive-dot',
    'barcode',
    'barcode2',
    'qrcode',
    'ticket',
    'ticket2',
    'theater',
    'store',
    'store2',
    'cart',
    'cart2',
    'cart3',
    'cart4',
    'cart5',
    'cart-add',
    'cart-add2',
    'cart-remove',
    'basket',
    'bag',
    'bag2',
    'percent',
    'coins',
    'coin-dollar',
    'coin-euro',
    'coin-pound',
    'coin-yen',
    'piggy-bank',
    'wallet',
    'cash',
    'cash2',
    'cash3',
    'cash4',
    'credit-card',
    'credit-card2',
    'calculator',
    'calculator2',
    'calculator3',
    'chip',
    'lifebuoy',
    'phone',
    'phone2',
    'phone-slash',
    'phone-wave',
    'phone-plus',
    'phone-minus',
    'phone-plus2',
    'phone-minus2',
    'phone-incoming',
    'phone-outgoing',
    'phone3',
    'phone-slash2',
    'phone-wave2',
    'phone-hang-up',
    'phone-hang-up2',
    'address-book',
    'address-book2',
    'address-book3',
    'notebook',
    'at-sign',
    'envelop',
    'envelop2',
    'envelop3',
    'envelop4',
    'envelop5',
    'mailbox',
    'pushpin',
    'pushpin2',
    'pin',
    'location',
    'location2',
    'location3',
    'location4',
    'location5',
    'location6',
    'location7',
    'compass',
    'compass2',
    'compass3',
    'compass4',
    'compass5',
    'compass6',
    'map',
    'map2',
    'map3',
    'map4',
    'map5',
    'direction',
    'reset',
    'history',
    'clock',
    'clock2',
    'clock3',
    'clock4',
    'watch',
    'watch2',
    'alarm',
    'alarm-add',
    'alarm-check',
    'alarm-cancel',
    'bell',
    'bell2',
    'bell3',
    'bell-plus',
    'bell-minus',
    'bell-check',
    'bell-cross',
    'stopwatch',
    'calendar',
    'calendar2',
    'calendar3',
    'calendar4',
    'calendar5',
    'calendar-empty',
    'calendar-day',
    'calendar-week',
    'printer',
    'printer2',
    'printer3',
    'printer4',
    'shredder',
    'mouse',
    'mouse2',
    'mouse-left',
    'mouse-right',
    'keyboard',
    'keyboard2',
    'typewriter',
    'display',
    'display2',
    'display3',
    'display4',
    'laptop',
    'mobile',
    'mobile2',
    'tablet',
    'mobile3',
    'tv',
    'radio',
    'cabinet',
    'drawer',
    'drawer2',
    'drawer-out',
    'drawer-in',
    'drawer3',
    'box',
    'box-add',
    'box-remove',
    'download',
    'upload',
    'floppy-disk',
    'floppy-disks',
    'floppy-disks2',
    'floppy-disk2',
    'floppy-disk3',
    'disk',
    'disk2',
    'usb-stick',
    'drive',
    'server',
    'database',
    'database2',
    'database3',
    'database4',
    'database-menu',
    'database-add',
    'database-remove',
    'database-insert',
    'database-export',
    'database-upload',
    'database-refresh',
    'database-diff',
    'database-edit',
    'database-edit2',
    'database-check',
    'database-arrow',
    'database-time',
    'database-time2',
    'undo',
    'redo',
    'rotate-ccw',
    'rotate-cw',
    'rotate-ccw2',
    'rotate-cw2',
    'rotate-ccw3',
    'rotate-cw3',
    'flip-vertical',
    'flip-vertical2',
    'flip-horizontal',
    'flip-horizontal2',
    'flip-vertical3',
    'flip-vertical4',
    'angle',
    'shear',
    'unite',
    'subtract',
    'interset',
    'exclude',
    'align-left',
    'align-center-horizontal',
    'align-right',
    'align-top',
    'align-center-vertical',
    'align-bottom',
    'undo2',
    'redo2',
    'forward',
    'reply',
    'reply-all',
    'bubble',
    'bubbles',
    'bubbles2',
    'bubble2',
    'bubbles3',
    'bubbles4',
    'bubble-notification',
    'bubbles5',
    'bubbles6',
    'bubble3',
    'bubble-dots',
    'bubble-lines',
    'bubble4',
    'bubble-dots2',
    'bubble-lines2',
    'bubble5',
    'bubble6',
    'bubbles7',
    'bubble7',
    'bubbles8',
    'bubble8',
    'bubble-dots3',
    'bubble-lines3',
    'bubble9',
    'bubble-dots4',
    'bubble-lines4',
    'bubbles9',
    'bubbles10',
    'bubble-blocked',
    'bubble-quote',
    'bubble-user',
    'bubble-smiley',
    'bubble-check',
    'bubble-video',
    'bubble-link',
    'bubble-lock',
    'bubble-star',
    'bubble-heart',
    'bubble-paperclip',
    'bubble-cancel',
    'bubble-plus',
    'bubble-minus',
    'bubble-notification2',
    'bubble-left',
    'bubble-right',
    'bubble-first',
    'bubble-last',
    'bubble-reply',
    'bubble-forward',
    'bubble-reply2',
    'bubble-forward2',
    'user',
    'users',
    'user-plus',
    'user-minus',
    'user-cancel',
    'user-block',
    'user-lock',
    'user-check',
    'users2',
    'user2',
    'users3',
    'user-plus2',
    'user-minus2',
    'user-cancel2',
    'user-block2',
    'user-lock2',
    'user-check2',
    'user3',
    'user4',
    'user5',
    'user6',
    'users4',
    'user-tie',
    'user7',
    'users5',
    'collaboration',
    'vcard',
    'hat',
    'bowtie',
    'tie',
    'hanger',
    'tshirt',
    'pants',
    'shorts',
    'sock',
    'laundry',
    'quotes-left',
    'quotes-right',
    'quotes-left2',
    'quotes-right2',
    'hour-glass',
    'hour-glass2',
    'hour-glass3',
    'spinner',
    'spinner2',
    'spinner3',
    'spinner4',
    'spinner5',
    'spinner6',
    'spinner7',
    'spinner8',
    'spinner9',
    'spinner10',
    'spinner11',
    'microscope',
    'binoculars',
    'binoculars2',
    'search',
    'zoom-in',
    'zoom-out',
    'search2',
    'zoom-in2',
    'zoom-out2',
    'search3',
    'search4',
    'zoom-in3',
    'zoom-out3',
    'search5',
    'search6',
    'enlarge',
    'shrink',
    'enlarge2',
    'shrink2',
    'enlarge3',
    'shrink3',
    'enlarge4',
    'shrink4',
    'enlarge5',
    'shrink5',
    'enlarge6',
    'shrink6',
    'enlarge7',
    'shrink7',
    'key',
    'key2',
    'key3',
    'key4',
    'key5',
    'keyhole',
    'lock',
    'lock2',
    'lock3',
    'lock4',
    'unlocked',
    'lock5',
    'unlocked2',
    'safe',
    'wrench',
    'wrench2',
    'wrench3',
    'equalizer',
    'equalizer2',
    'equalizer3',
    'equalizer4',
    'cog',
    'cogs',
    'cog2',
    'cog3',
    'cog4',
    'cog5',
    'cog6',
    'cog7',
    'factory',
    'hammer',
    'hammer-wrench',
    'knife',
    'screwdriver',
    'screwdriver2',
    'magic-wand',
    'magic-wand2',
    'pulse',
    'pulse2',
    'aid-kit',
    'aid-kit2',
    'stethoscope',
    'ambulance',
    'alarm2',
    'pandage',
    'pandage2',
    'bug',
    'bug2',
    'syringe',
    'syringe2',
    'pill',
    'construction',
    'traffic-cone',
    'traffic-lights',
    'pie-chart',
    'pie-chart2',
    'pie-chart3',
    'pie-chart4',
    'pie-chart5',
    'pie-chart6',
    'pie-chart7',
    'stats-dots',
    'stats-bars',
    'pie-chart8',
    'stats-bars2',
    'stats-bars3',
    'stats-bars4',
    'stats-bars5',
    'stats-bars6',
    'chart',
    'stats-growth',
    'stats-decline',
    'stats-growth2',
    'stats-decline2',
    'stairs-up',
    'stairs-down',
    'stairs',
    'stairs2',
    'ladder',
    'rating',
    'rating2',
    'rating3',
    'cake',
    'podium',
    'stars',
    'medal-star',
    'medal',
    'medal2',
    'medal-first',
    'medal-second',
    'medal-third',
    'crown',
    'trophy',
    'trophy2',
    'trophy3',
    'diamond',
    'diamond2',
    'trophy4',
    'gift',
    'gift2',
    'balloon',
    'pipe',
    'mustache',
    'mustache2',
    'glass',
    'glass2',
    'glass3',
    'glass4',
    'bottle',
    'bottle2',
    'bottle3',
    'bottle4',
    'mug',
    'fork-knife',
    'spoon-knife',
    'cook',
    'plate',
    'steak',
    'fish',
    'chicken',
    'hamburger',
    'pizza',
    'cheese',
    'bread',
    'icecream',
    'milk',
    'cup',
    'cup2',
    'coffee-bean',
    'coffee',
    'teapot',
    'leaf',
    'leaf2',
    'apple',
    'grapes',
    'cherry',
    'tree',
    'tree2',
    'tree3',
    'tree4',
    'cactus',
    'mountains',
    'paw',
    'footprint',
    'tent',
    'flower',
    'flower2',
    'rocket',
    'meter',
    'meter2',
    'meter-slow',
    'meter-medium',
    'meter-fast',
    'meter3',
    'hammer2',
    'balance',
    'scale',
    'bomb',
    'fire',
    'fire2',
    'lab',
    'atom',
    'atom2',
    'magnet',
    'magnet2',
    'dumbbell',
    'skull',
    'skull2',
    'lamp',
    'lamp2',
    'lamp3',
    'spotlight',
    'lamp4',
    'lamp5',
    'lamp6',
    'lamp7',
    'lamp8',
    'broom',
    'toiletpaper',
    'bin',
    'bin2',
    'bin3',
    'bin4',
    'bin5',
    'briefcase',
    'briefcase2',
    'briefcase3',
    'airplane',
    'airplane2',
    'airplane3',
    'airplane4',
    'paperplane',
    'car',
    'steering-wheel',
    'car2',
    'gas',
    'bus',
    'truck',
    'bike',
    'road',
    'train',
    'train2',
    'ship',
    'boat',
    'chopper',
    'chopper2',
    'cube',
    'cube2',
    'cube3',
    'cube4',
    'pyramid',
    'pyramid2',
    'package',
    'puzzle',
    'puzzle2',
    'puzzle3',
    'puzzle4',
    'glasses-3d',
    'glasses-3d2',
    'glasses',
    'glasses2',
    'brain',
    'accessibility',
    'accessibility2',
    'strategy',
    'target',
    'target2',
    'target3',
    'ammo',
    'gun',
    'gun-forbidden',
    'shield',
    'shield-check',
    'shield-notice',
    'shield2',
    'shield3',
    'shield4',
    'soccer',
    'football',
    'archery',
    'bow',
    'sword',
    'tennis',
    'pingpong',
    'baseball',
    'basketball',
    'golf',
    'golf2',
    'hockey',
    'racing',
    'finish',
    'eight-ball',
    'bowling',
    'bowling2',
    'power',
    'power2',
    'power3',
    'switch',
    'switch2',
    'power-cord',
    'power-cord2',
    'outlet',
    'clipboard',
    'clipboard2',
    'clipboard3',
    'clipboard4',
    'clipboard5',
    'clipboard6',
    'playlist',
    'playlist-add',
    'list-numbered',
    'list',
    'list2',
    'more',
    'more2',
    'grid',
    'grid2',
    'grid3',
    'grid4',
    'grid5',
    'grid6',
    'grid7',
    'tree5',
    'tree6',
    'tree7',
    'lan',
    'lan2',
    'lan3',
    'menu',
    'circle-small',
    'menu2',
    'menu3',
    'menu4',
    'menu5',
    'menu6',
    'menu7',
    'kebab',
    'menu8',
    'menu9',
    'menu10',
    'cloud',
    'cloud-download',
    'cloud-upload',
    'cloud-check',
    'cloud2',
    'cloud-download2',
    'cloud-upload2',
    'cloud-check2',
    'download2',
    'download3',
    'upload2',
    'upload3',
    'import',
    'import2',
    'download4',
    'upload4',
    'download5',
    'upload5',
    'download6',
    'upload6',
    'download7',
    'upload7',
    'download8',
    'upload8',
    'download9',
    'upload9',
    'download10',
    'upload10',
    'sphere',
    'sphere2',
    'sphere3',
    'planet',
    'planet2',
    'earth',
    'earth2',
    'earth3',
    'link',
    'unlink',
    'link2',
    'unlink2',
    'link3',
    'unlink3',
    'link4',
    'unlink4',
    'link5',
    'unlink5',
    'anchor',
    'flag',
    'flag2',
    'flag3',
    'flag4',
    'flag5',
    'flag6',
    'flag7',
    'flag8',
    'attachment',
    'attachment2',
    'eye',
    'eye-plus',
    'eye-minus',
    'eye-blocked',
    'eye2',
    'eye-blocked2',
    'eye3',
    'eye-blocked3',
    'eye4',
    'bookmark2',
    'bookmark3',
    'bookmarks',
    'bookmark4',
    'spotlight2',
    'starburst',
    'snowflake',
    'temperature',
    'temperature2',
    'weather-lightning',
    'weather-lightning2',
    'weather-rain',
    'weather-rain2',
    'weather-snow',
    'weather-snow2',
    'weather-cloud-wind',
    'weather-cloud-wind2',
    'weather-cloud-sun',
    'weather-cloud-sun2',
    'weather-cloudy',
    'weather-cloudy2',
    'weather-sun-wind',
    'weather-sun-wind2',
    'sun',
    'sun2',
    'moon',
    'day-night',
    'day-night2',
    'weather-windy',
    'fan',
    'umbrella',
    'sun3',
    'contrast',
    'brightness-contrast',
    'brightness-high',
    'brightness-medium',
    'brightness-low',
    'bed',
    'bed2',
    'furniture',
    'chair',
    'star-empty',
    'star-empty2',
    'star-full',
    'star-empty3',
    'star-half',
    'star-full2',
    'star',
    'heart',
    'heart2',
    'heart3',
    'heart4',
    'heart-broken',
    'heart5',
    'heart6',
    'heart-broken2',
    'heart7',
    'heart8',
    'heart-broken3',
    'lips',
    'lips2',
    'thumbs-up',
    'thumbs-up2',
    'thumbs-down',
    'thumbs-down2',
    'thumbs-up3',
    'thumbs-down3',
    'height',
    'man',
    'woman',
    'man-woman',
    'male',
    'female',
    'peace',
    'yin-yang',
    'happy',
    'happy2',
    'smile',
    'smile2',
    'tongue',
    'tongue2',
    'sad',
    'sad2',
    'wink',
    'wink2',
    'grin',
    'grin2',
    'cool',
    'cool2',
    'angry',
    'angry2',
    'evil',
    'evil2',
    'shocked',
    'shocked2',
    'baffled',
    'baffled2',
    'confused',
    'confused2',
    'neutral',
    'neutral2',
    'hipster',
    'hipster2',
    'wondering',
    'wondering2',
    'sleepy',
    'sleepy2',
    'frustrated',
    'frustrated2',
    'crying',
    'crying2',
    'cursor',
    'cursor2',
    'lasso',
    'lasso2',
    'select',
    'select2',
    'point-up',
    'point-right',
    'point-down',
    'point-left',
    'pointer',
    'reminder',
    'drag-left-right',
    'drag-left',
    'drag-right',
    'touch',
    'multitouch',
    'touch-zoom',
    'touch-pinch',
    'hand',
    'grab',
    'stack-empty',
    'stack-plus',
    'stack-minus',
    'stack-star',
    'stack-picture',
    'stack-down',
    'stack-up',
    'stack-cancel',
    'stack-check',
    'stack-text',
    'stack-clubs',
    'stack-spades',
    'stack-hearts',
    'stack-diamonds',
    'stack-user',
    'stack4',
    'stack-music',
    'stack-play',
    'move',
    'dots',
    'warning',
    'warning2',
    'notification',
    'notification2',
    'question',
    'question2',
    'question3',
    'question4',
    'question5',
    'question6',
    'plus',
    'add',
    'icon-arrow-down5',
    'icon-arrow-up5',
    'minus',
    'plus2',
    'plus22',
    'minus2',
    'plus3',
    'minus3',
    'plus-circle',
    'minus-circle',
    'plus-circle2',
    'minus-circle2',
    'info',
    'info2',
    'cancel-circle',
    'cancel-circle2',
    'blocked',
    'cancel-square',
    'cancel-square2',
    'cancel',
    'spam',
    'cross',
    'cross2',
    'cross3',
    'checkmark',
    'checkmark2',
    'checkmark3',
    'checkmark4',
    'checkmark5',
    'spell-check',
    'spell-check2',
    'enter',
    'exit',
    'enter2',
    'exit2',
    'enter3',
    'exit3',
    'wall',
    'fence',
    'play3',
    'pause',
    'stop',
    'previous',
    'next',
    'backward',
    'forward2',
    'play4',
    'pause2',
    'stop2',
    'backward2',
    'forward3',
    'first',
    'last',
    'previous2',
    'next2',
    'eject',
    'volume-high',
    'volume-medium',
    'volume-low',
    'volume-mute',
    'speaker-left',
    'speaker-right',
    'volume-mute2',
    'volume-increase',
    'volume-decrease',
    'volume-high2',
    'volume-medium2',
    'volume-medium3',
    'volume-low2',
    'volume-mute3',
    'volume-increase2',
    'volume-decrease2',
    'volume-decrease3',
    'volume-5',
    'volume-4',
    'volume-3',
    'volume-2',
    'volume-1',
    'volume-0',
    'volume-mute4',
    'volume-mute5',
    'loop',
    'loop2',
    'loop3',
    'infinite-square',
    'infinite',
    'infinite2',
    'loop4',
    'shuffle',
    'shuffle2',
    'wave',
    'wave2',
    'split',
    'merge',
    'first2',
    'last2',
    'arrow-up',
    'arrow-up2',
    'arrow-up3',
    'arrow-up4',
    'arrow-right',
    'arrow-right2',
    'arrow-right3',
    'arrow-right4',
    'arrow-down',
    'arrow-down2',
    'arrow-down3',
    'arrow-down4',
    'arrow-left',
    'arrow-left2',
    'arrow-left3',
    'arrow-left4',
    'arrow-up5',
    'arrow-right5',
    'arrow-down5',
    'arrow-left5',
    'arrow-up-left',
    'arrow-up6',
    'arrow-up-right',
    'arrow-right6',
    'arrow-down-right',
    'arrow-down6',
    'arrow-down-left',
    'arrow-left6',
    'arrow-up-left2',
    'arrow-up7',
    'arrow-up-right2',
    'arrow-right7',
    'arrow-down-right2',
    'arrow-down7',
    'arrow-down-left2',
    'arrow-left7',
    'arrow-up-left3',
    'arrow-up8',
    'arrow-up-right3',
    'arrow-right8',
    'arrow-down-right3',
    'arrow-down8',
    'arrow-down-left3',
    'arrow-left8',
    'circle-up',
    'circle-right',
    'circle-down',
    'circle-left',
    'circle-up2',
    'circle-right2',
    'circle-down2',
    'circle-left2',
    'circle-up-left',
    'circle-up3',
    'circle-up-right',
    'circle-right3',
    'circle-down-right',
    'circle-down3',
    'circle-down-left',
    'circle-left3',
    'circle-up-left2',
    'circle-up4',
    'circle-up-right2',
    'circle-right4',
    'circle-down-right2',
    'circle-down4',
    'circle-down-left2',
    'circle-left4',
    'arrow-resize',
    'arrow-resize2',
    'arrow-resize3',
    'arrow-resize4',
    'arrow-resize5',
    'arrow-resize6',
    'arrow-resize7',
    'arrow-resize8',
    'square-up-left',
    'square-up',
    'square-up-right',
    'square-right',
    'square-down-right',
    'square-down',
    'square-down-left',
    'square-left',
    'arrow-up9',
    'arrow-right9',
    'arrow-down9',
    'arrow-left9',
    'arrow-up10',
    'arrow-right10',
    'arrow-down10',
    'arrow-left10',
    'arrow-up-left4',
    'arrow-up11',
    'arrow-up-right4',
    'arrow-right11',
    'arrow-down-right4',
    'arrow-down11',
    'arrow-down-left4',
    'arrow-left11',
    'arrow-up-left5',
    'arrow-up12',
    'arrow-up-right5',
    'arrow-right12',
    'arrow-down-right5',
    'arrow-down12',
    'arrow-down-left5',
    'arrow-left12',
    'arrow-up13',
    'arrow-right13',
    'arrow-down13',
    'arrow-left13',
    'arrow-up14',
    'arrow-right14',
    'arrow-down14',
    'arrow-left14',
    'circle-up5',
    'circle-right5',
    'circle-down5',
    'circle-left5',
    'circle-up6',
    'circle-right6',
    'circle-down6',
    'circle-left6',
    'arrow-up15',
    'arrow-right15',
    'arrow-down15',
    'arrow-left15',
    'arrow-up16',
    'arrow-right16',
    'arrow-down16',
    'arrow-left16',
    'menu-open',
    'menu-open2',
    'menu-close',
    'menu-close2',
    'enter4',
    'enter5',
    'esc',
    'enter6',
    'backspace',
    'backspace2',
    'tab',
    'transmission',
    'transmission2',
    'sort',
    'sort2',
    'move-up',
    'move-down',
    'sort-alpha-asc',
    'sort-alpha-desc',
    'sort-numeric-asc',
    'sort-numberic-desc',
    'sort-amount-asc',
    'sort-amount-desc',
    'sort-time-asc',
    'sort-time-desc',
    'battery-6',
    'battery-5',
    'battery-4',
    'battery-3',
    'battery-2',
    'battery-1',
    'battery-0',
    'battery-charging',
    'key-keyboard',
    'key-A',
    'key-up',
    'key-right',
    'key-down',
    'key-left',
    'command',
    'comment',
    'shift',
    'ctrl',
    'opt',
    'checkbox-checked',
    'checkbox-unchecked',
    'checkbox-partial',
    'square',
    'triangle',
    'triangle2',
    'diamond3',
    'diamond4',
    'checkbox-checked2',
    'checkbox-unchecked2',
    'checkbox-partial2',
    'radio-checked',
    'radio-checked2',
    'radio-unchecked',
    'toggle-on',
    'toggle-off',
    'checkmark-circle',
    'circle',
    'circle2',
    'circles',
    'circles2',
    'crop',
    'crop2',
    'make-group',
    'ungroup',
    'vector',
    'vector2',
    'rulers',
    'ruler',
    'pencil-ruler',
    'scissors',
    'scissors2',
    'scissors3',
    'haircut',
    'comb',
    'filter',
    'filter2',
    'filter3',
    'filter4',
    'font',
    'ampersand',
    'ligature',
    'ligature2',
    'font-size',
    'typography',
    'text-height',
    'text-width',
    'height2',
    'width',
    'bold',
    'underline',
    'italic',
    'strikethrough',
    'strikethrough2',
    'font-size2',
    'bold2',
    'underline2',
    'italic2',
    'strikethrough3',
    'omega',
    'sigma',
    'nbsp',
    'page-break',
    'page-break2',
    'superscript',
    'subscript',
    'superscript2',
    'subscript2',
    'text-color',
    'highlight',
    'pagebreak',
    'clear-formatting',
    'table',
    'table2',
    'insert-template',
    'pilcrow',
    'ltr',
    'rtl',
    'ltr2',
    'rtl2',
    'section',
    'paragraph-left',
    'paragraph-center',
    'paragraph-right',
    'paragraph-justify',
    'paragraph-left2',
    'paragraph-center2',
    'paragraph-right2',
    'paragraph-justify2',
    'indent-increase',
    'indent-decrease',
    'paragraph-left3',
    'paragraph-center3',
    'paragraph-right3',
    'paragraph-justify3',
    'indent-increase2',
    'indent-decrease2',
    'share',
    'share2',
    'new-tab',
    'new-tab2',
    'popout',
    'embed',
    'embed2',
    'markup',
    'regexp',
    'regexp2',
    'code',
    'circle-css',
    'circle-code',
    'terminal',
    'unicode',
    'seven-segment-0',
    'seven-segment-1',
    'seven-segment-2',
    'seven-segment-3',
    'seven-segment-4',
    'seven-segment-5',
    'seven-segment-6',
    'seven-segment-7',
    'seven-segment-8',
    'seven-segment-9',
    'share3',
    'share4',
    'mail',
    'mail2',
    'mail3',
    'mail4',
    'amazon',
    'google',
    'google2',
    'google3',
    'google-plus',
    'google-plus2',
    'google-plus3',
    'hangouts',
    'google-drive',
    'facebook',
    'facebook2',
    'instagram',
    'whatsapp',
    'spotify',
    'telegram',
    'twitter',
    'vine',
    'vk',
    'renren',
    'sina-weibo',
    'rss',
    'rss2',
    'youtube',
    'youtube2',
    'twitch',
    'vimeo',
    'vimeo2',
    'lanyrd',
    'flickr',
    'flickr2',
    'flickr3',
    'flickr4',
    'dribbble',
    'behance',
    'behance2',
    'deviantart',
    '500px',
    'steam',
    'steam2',
    'dropbox',
    'onedrive',
    'github',
    'npm',
    'basecamp',
    'trello',
    'wordpress',
    'joomla',
    'ello',
    'blogger',
    'blogger2',
    'tumblr',
    'tumblr2',
    'yahoo',
    'yahoo2',
    'tux',
    'appleinc',
    'finder',
    'android',
    'windows',
    'windows8',
    'soundcloud',
    'soundcloud2',
    'skype',
    'reddit',
    'hackernews',
    'wikipedia',
    'linkedin',
    'linkedin2',
    'lastfm',
    'lastfm2',
    'delicious',
    'stumbleupon',
    'stumbleupon2',
    'stackoverflow',
    'pinterest',
    'pinterest2',
    'xing',
    'xing2',
    'flattr',
    'foursquare',
    'yelp',
    'paypal',
    'chrome',
    'firefox',
    'IE',
    'edge',
    'safari',
    'opera',
    'file-pdf',
    'file-openoffice',
    'file-word',
    'file-excel',
    'libreoffice',
    'html-five',
    'html-five2',
    'css3',
    'git',
    'codepen',
    'svg',
];
